import { createListenerMiddleware, isAnyOf } from "@reduxjs/toolkit";
import type { AppDispatch, RootState } from "../../app/store";
import {
  hydrateSessionData,
  startNewSession,
  setAccessCode,
  setUserId,
  setPostSurveyTime,
} from "./sessionDataSlice";
import { sendEvent, sessionStartEventBuilder } from "../../utils/event-helpers";
import { SESSION_DATA_LS_KEY } from "./initializeSessionData";

export const sessionListenerMiddleware = createListenerMiddleware();

const startAppListening = sessionListenerMiddleware.startListening.withTypes<
  RootState,
  AppDispatch
>();

startAppListening({
  matcher: isAnyOf(
    hydrateSessionData,
    startNewSession,
    setAccessCode,
    setUserId,
    setPostSurveyTime,
  ),
  effect: (_action, listenerApi) => {
    const state = listenerApi.getState();
    localStorage.setItem(SESSION_DATA_LS_KEY, JSON.stringify(state.session));
  },
});

startAppListening({
  actionCreator: startNewSession,
  effect: (_action, listenerApi) => {
    const state = listenerApi.getState();
    const { userId, sessionId } = state.session;

    if (!userId || !sessionId) return;
    void listenerApi.dispatch(
      sendEvent(sessionStartEventBuilder(userId, sessionId)),
    );
  },
});
